import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=bc3f07a2&"
import script from "./CreateEmail.vue?vue&type=script&lang=js&"
export * from "./CreateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports